export default "__VITE_ASSET__Cz05Tl4P__"